// extracted by mini-css-extract-plugin
export default {"panel":"panel--z39kF"};